<template>
    <div class="validation-messages">
        <slot></slot>

        <div class="error" v-if="$v.$error">
            <div v-if="$v.required === false || $v.requiredIf === false">{{ label }} is required</div>

            <div v-else-if="$v.numeric === false">{{ label }} must be numbers only.</div>

            <div v-else-if="$v.decimal === false">{{ label }} must be valid decimal.</div>

            <div v-else-if="$v.between === false">
                {{ label }} must be between {{ $v.$params.between.min }} & {{ $v.$params.between.max }}.
            </div>

            <div v-else-if="$v.alpha === false">{{ label }} must be letters only.</div>

            <div v-else-if="$v.alphaNum === false">{{ label }} must be letters and numbers only.</div>

            <div v-else-if="$v.maxValue === false">
                {{ label }} can't be more than {{ $v.$params.maxValue.max }}
            </div>

            <div v-else-if="$v.minValue === false">
                {{ label }} can't be less than {{ $v.$params.minValue.min }}
            </div>

            <div v-else-if="$v.minLength === false">
                {{ label }} must be at least {{ $v.$params.minLength.min }} characters.
            </div>

            <div v-else-if="$v.maxLength === false">
                {{ label }} exceeds {{ $v.$params.maxLength.max }} characters.
            </div>

            <div v-else-if="$v.email === false">Email is invalid.</div>

            <div v-else-if="$v.regex === false">{{ label }} is invalid.</div>

            <slot v-else name="error"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ValidationMessages',
    props: {
        label: String,
        $v: Object
    }
};
</script>

<style lang="scss">
.validation-messages {
    position: relative;
    float: left;
    width: 100%;

    >.error {
        padding: 12px 20px;
        position: absolute;
        left: 0;
        opacity: 0;
        font-size: 12px;
        z-index: 500;
        width: 100%;
        color: #fff;
        border-radius: 4px;
        background-color: #ff4444;
        transition: opacity 300ms ease;
    }

    &:hover,
    &:focus {
        >.error {
            opacity: 1;
        }
    }
}
</style>
